<template>
    <div id="user-edit-info" class="modal fade" tabindex="-1" aria-labelledby="#user-show-info"
         aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Crear una nueva plantilla</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
                </div>

                <div class="modal-body">
                    <div class="user-form">
                        <div class="form-group">
                            <label>Nombre:</label>
                            <input type="text" class="form-control" v-model="template.name"/>
                        </div>

                        <div class="form-group">
                            <template v-for="role in availableRoles">
                                <div class="form-check" v-if="role.name !== 'administrador'">
                                    <input class="form-check-input" type="checkbox" :value="role.id" :name="role.name" :id="role.name" @change="updateRoles">
                                    <label class="form-check-label" :for="role.name">
                                        {{ formatRoleName(role.name) }}
                                    </label>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <ul class="form-errors">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
                    <button type="button" class="btn btn-primary" @click="checkForm">Guardar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Modal} from 'bootstrap';
import {createTemplate} from "../../../../helpers/requests/RequestsTemplates";
import router from "../../../../router";
import {getRoles} from "../../../../helpers/requests/RequestsRoles";

export default {
    name: "TemplatesListAddModal",
    data() {
        return {
            template: {
                name: '',
                roles: [],
            },
            availableRoles: [],

            errors: [],
            modal: null
        }
    },
    async mounted() {
        this.modal = new Modal(this.$refs.modal);
        this.modal.show();

        this.availableRoles = await getRoles();

        this.$refs.modal.addEventListener('hidden.bs.modal', () => {
            this.$emit('close');
        });
    },
    methods: {
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        checkForm() {
            this.errors = [];

            if (!this.template.name) {
                this.errors.push('Escribe un nombre para la plantilla');
            }

            if (this.errors.length > 0) {
                return this.errors;
            } else {
                this.createTemplate();
            }
        },
        async createTemplate() {
            try {
                // By now we are forcing this. Types will be applied in a future phase if needed, and content will be edited in other vue component
                let type = 'general';
                let content = '<p style="color: red;">Plantilla vacía. Debes editarla para crear un contenido que poder utilizar.</p>';

                // roles must be an array of roles ids

                let res = await createTemplate(this.template.name, type, content, this.template.roles);

                await router.push({ name: 'template.update', params: { template: res.id } });
                // if ok, close modal

                this.closeModal();

                this.$store.dispatch('app/setToastMessage', 'Plantilla creada, ahora edita el contenido.');
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'No se ha podido crear la plantilla');
            }
        },
        updateRoles(e) {
            let value = e.target.value;
            let role_id = e.target.value;

            if (e.target.type === 'checkbox') {
                // As string to be stored in form_values table
                value = e.target.checked + "";
            }

            if (value === 'true') {
                const index = this.template.roles.indexOf(role_id);
                if (index <= -1) {
                    this.template.roles.push(role_id);
                }
            } else {
                const index = this.template.roles.indexOf(role_id);
                if (index > -1) {
                    this.template.roles.splice(index, 1);
                }
            }
        },
        closeModal() {
            this.modal.hide();
        }
    },
    setup() {
        return {
            router,
        }
    }
}
</script>
